import React from "react";
import authRoute from "../../src/components/Authentication/authRoute";
import WithLayout from "../../src/components/Hoc/withLayout";
import SettingsLayout from "../../src/components/Layout/SettingsLayout";
import ApiKeys from "../../src/components/Settings/ApiKeys";

const apiKeys = () => {
  return (
    <SettingsLayout title="API Keys">
      <ApiKeys />
    </SettingsLayout>
  );
};

export default authRoute(WithLayout(apiKeys, "API Keys"));
